import withAuth from "../../../../contexts/AuthContext/withAuth";
import FormCreateNewUser from "./FormCreateNewUser";


export default withAuth(FormCreateNewUser)